import { render, staticRenderFns } from "./StartendDate.vue?vue&type=template&id=8564a752&scoped=true&"
import script from "./StartendDate.vue?vue&type=script&lang=js&"
export * from "./StartendDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8564a752",
  null
  
)

export default component.exports